import React from 'react';
import { fontFamily, radius } from '../../theming';

const ExtensionConfidencePrivacyPolicy = () => {
    return (
        <div
            style={{
                padding: '20px',
                maxWidth: '860px',
                margin: '0 auto',
            }}
        >
            <header
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <h1 style={{ marginBottom: '0px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Privacy Policy
                </h1>
                <p style={{ marginTop: '12px', fontSize: '16px', lineHeight: '24px' }}>Last Updated: 23 May 2025</p>
            </header>
            <main style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <section>
                    <h2>1. Introduction</h2>
                    <p style={{ fontSize: '16px', lineHeight: '24px' }}>
                        Welcome to our Chrome Extension. We are committed to protecting your privacy and ensuring you
                        have a positive experience while using our service. This Privacy Policy explains how we handle
                        your data and your rights regarding your personal information.
                    </p>
                </section>

                <section>
                    <h2>2. Data Collection & Usage</h2>
                    <p style={{ fontSize: '16px', lineHeight: '24px' }}>What We Don't Collect:</p>
                    <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <li>Personal identification information</li>
                        <li>Browsing history</li>
                        <li>Cookies and similar technologies</li>
                        <li>Usage data</li>
                    </ul>

                    <p style={{ fontSize: '16px', lineHeight: '24px' }}>
                        Our extension operates entirely locally within your browser. The only data processing occurs
                        when you actively choose to decode a VIN number, which opens in a new tab on our secure decoding
                        service.
                    </p>
                </section>

                <section>
                    <h2>3. Third-Party Services</h2>
                    <p style={{ fontSize: '16px', lineHeight: '24px' }}>
                        When you choose to decode a VIN number, you'll be redirected to our secure decoding service.
                        This interaction is:
                    </p>

                    <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <li>User-initiated and transparent</li>
                        <li>Protected by industry-standard security measures</li>
                        <li>Compliant with data protection regulations</li>
                    </ul>
                </section>

                <section>
                    <h2>4. Your Rights</h2>
                    <p style={{ fontSize: '16px', lineHeight: '24px' }}>
                        You have complete control over your data. You can:
                    </p>
                    <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <li>Uninstall the extension at any time</li>
                        <li>Choose not to use the VIN decoding feature</li>
                        <li>Request information about any data we might have</li>
                    </ul>
                </section>

                <section>
                    <h2>5. Contact Us</h2>
                    <p style={{ fontSize: '16px', lineHeight: '24px' }}>
                        If you have any questions or concerns about our Privacy Policy, please contact us at{' '}
                        <a href="mailto:info@checkvin.ai">info@checkvin.ai</a>.
                    </p>
                </section>
            </main>
            <footer>
                <p>© 2025 CheckVin. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default ExtensionConfidencePrivacyPolicy;
